import {
    ChangeDetectionStrategy,
    Component,
} from '@angular/core';
import { IQueueItem } from '@models';
import { JobTriggerBaseComponent } from '@pages/jobs/grids/job-triggers';
import { QueueItemService } from '@services';

@Component({
    selector: 'ui-job-trigger-queue-item',
    templateUrl: './job-trigger-queue-item.component.html',
    styleUrls: ['./job-trigger-queue-item.component.scss'],
    providers: [QueueItemService],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobTriggerQueueItemComponent extends JobTriggerBaseComponent<IQueueItem> {

    constructor(private _queueItemService: QueueItemService) {
        super();
    }

    protected _fetchItem = () => this._queueItemService.getItemLastRetry(this._itemId, ['QueueDefinition', 'ReviewerUser']);
}
